/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Chkk Admin API v1.0
 * Chkk Admin API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * The status of an upgrade assessment
 */
export type UpgradeAssessmentStatus =
  (typeof UpgradeAssessmentStatus)[keyof typeof UpgradeAssessmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpgradeAssessmentStatus = {
  pending: 'pending',
  'in-progress': 'in-progress',
  ready: 'ready',
  failed: 'failed',
  outdated: 'outdated',
  archived: 'archived',
} as const;
